<template>
  <div class="blumar-alert">
    <b-alert :show="show" :variant="alertStyle" :dismissible="dismissible" fade @dismissed="hide()">
      <span v-html="alertText"></span>
    </b-alert>
  </div>
</template>

<script>
export default {
  methods: {
    hide() {
      this.$store.dispatch("hideAlert");
    }
  },
  computed: {
    show() {
      return this.$store.getters.showAlert;
    },
    alertText() {
      return this.$store.getters.alertMessage;
    },
    alertStyle() {
      return this.$store.getters.alertStyle;
    },
    dismissible(){
      return this.$store.getters.alertDismissible;
    }
  },
  watch: {
    '$route' () {
      if(this.$store.state.alert.closeOnChangeRoute)
        this.hide();
    }
  }
};
</script>

<style scoped>
.blumar-alert {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1000000;
  bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BlumarAlert.vue